// This value might be eventually set via a config parameter
export var DEFAULT_CACHE_EXPIRATION_IN_MILLIS = 864000000; // 10 days